
<anime :enter="enter" :leave="leave" :before-enter="beforeEnter">
  <slot></slot>
</anime>
